import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  DashboardIcon,
  ContactIcon,
  EmployeeIcon,
  TemplatesIcon,
  MasterIcon,
  SettingIcon,
  ReportIcon
} from ".";
import { PATHS } from "../constant";

class SidebarComp extends PureComponent {
  render() {
    const { className, toggleSideBar } = this.props;
    return (
      <nav className={`${className} ${toggleSideBar ? "collapse" : ""}`}>
        <ul>
          <li>
            <NavLink exact to="/">
              <span className="left-border" />
              <DashboardIcon className="left_position" />
              <span className="link-name">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={`${PATHS.CONTACT}`}>
              <span className="left-border" />
              <ContactIcon className="left_position" />
              <span className="link-name">Contacts</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/employee">
              <span className="left-border" />
              <EmployeeIcon className="left_position" />
              <span className="link-name">Users</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/templates">
              <span className="left-border" />
              <TemplatesIcon className="left_position" />
              <span className="link-name">Templates</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/master">
              <span className="left-border" />
              <MasterIcon className="left_position" />
              <span className="link-name">Roles</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/mapping">
              <span className="left-border" />
              <SettingIcon className="left_position" />
              <span className="link-name multiple-line">Settings</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/reports">
              <span className="left-border" />
              <ReportIcon className="left_position" />
              <span className="link-name">Reports</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    );
  }
}

SidebarComp.propTypes = {
  className: PropTypes.string,
  toggleSideBar: PropTypes.bool
};

SidebarComp.defaultProps = {
  className: "",
  toggleSideBar: false
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    toggleSideBar: state.commonReducer.toggleSideBar
  };
}

export const Sidebar = styled(connect(mapStateToProps)(SidebarComp))`
  box-shadow: 0px 3px 7px 0 rgba(25, 29, 28, 0.35);
  min-height: calc(100vh - 70px);
  position: relative;
  width: 200px;
  opacity: 1;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  &.collapse {
    width: 60px;
    .link-name {
      overflow: hidden;
      width: 0;
      height: 0;
    }
  }
  ul {
    margin: 0;
    padding: 0;
  }
  li a {
    display: block;
    align-items: center;
    color: ${({ theme }) => theme.palette.DARKGREY2};
    text-decoration: none;
    height: 70px;
    white-space: nowrap;
    width: 200px;
    border-bottom: ${({ theme }) =>
      theme.border.normal(theme.palette.LIGHTGREY2)};
    svg {
      position: absolute;
      padding-top: 25px;
      width: 30px;
      height: 49px;
    }
    .link-name {
      float: left;
      position: relative;
      top: 28px;
      left: 39px;
      color: ${({ theme }) => theme.palette.BLACK};
      &.multiple-line {
        width: 120px;
        top: 17px;
        white-space: normal;
      }
    }
    .left-border {
      float: left;
      width: 5px;
      background: ${({ theme }) => theme.palette.WHITE};
      height: 100%;
      margin-right: 15px;
    }
    &.active {
      color: ${({ theme }) => theme.palette.BLACK};
      path {
        fill: #000;
      }
      .left-border {
        background: ${({ theme }) => theme.palette.PRIMARY};
        box-shadow: 0px 3px 7px 0 rgba(0, 199, 178, 0.35);
      }
    }
    &:hover {
      color: ${({ theme }) => theme.palette.BLACK};
      path {
        fill: #000;
      }
    }
  }
  .left_position {
    left: 15px;
  }
`;
